import { render, staticRenderFns } from "./ContactsSummary.vue?vue&type=template&id=633a8cda&"
import script from "./ContactsSummary.vue?vue&type=script&lang=js&"
export * from "./ContactsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSummary.vue?vue&type=style&index=0&id=633a8cda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports